import React from "react";
import { ProducerNameCellTemplate } from "themes/administration/producer/components";

function ProducerNameCell(props) {
    return <ProducerNameCellTemplate {...props} />;
}

export default ProducerNameCell;
